'use strict';
import * as $j_app$002elayouts$002e$002dMain$002dLayout$0024$002dDisplay$002dName$00241 from "./app.layouts.-Main-Layout$-Display-Name$1.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_layouts_MainLayout$DisplayName$3$Impersonating(outer, name) {
  this.Lapp_layouts_MainLayout$DisplayName$3$Impersonating__f_name = null;
  this.Lapp_layouts_MainLayout$DisplayName$3$Impersonating__f_$outer = null;
  this.Lapp_layouts_MainLayout$DisplayName$3$Impersonating__f_name = name;
  if ((outer === null)) {
    throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_NullPointerException__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_NullPointerException());
  }
  this.Lapp_layouts_MainLayout$DisplayName$3$Impersonating__f_$outer = outer;
}
export { $c_Lapp_layouts_MainLayout$DisplayName$3$Impersonating as $c_Lapp_layouts_MainLayout$DisplayName$3$Impersonating };
$c_Lapp_layouts_MainLayout$DisplayName$3$Impersonating.prototype = new $j_app$002elayouts$002e$002dMain$002dLayout$0024$002dDisplay$002dName$00241.$h_Lapp_layouts_MainLayout$DisplayName$1();
$c_Lapp_layouts_MainLayout$DisplayName$3$Impersonating.prototype.constructor = $c_Lapp_layouts_MainLayout$DisplayName$3$Impersonating;
/** @constructor */
function $h_Lapp_layouts_MainLayout$DisplayName$3$Impersonating() {
}
export { $h_Lapp_layouts_MainLayout$DisplayName$3$Impersonating as $h_Lapp_layouts_MainLayout$DisplayName$3$Impersonating };
$h_Lapp_layouts_MainLayout$DisplayName$3$Impersonating.prototype = $c_Lapp_layouts_MainLayout$DisplayName$3$Impersonating.prototype;
$c_Lapp_layouts_MainLayout$DisplayName$3$Impersonating.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1902162089, true);
});
$c_Lapp_layouts_MainLayout$DisplayName$3$Impersonating.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || (((x$0 instanceof $c_Lapp_layouts_MainLayout$DisplayName$3$Impersonating) && (x$0.Lapp_layouts_MainLayout$DisplayName$3$Impersonating__f_$outer === this.Lapp_layouts_MainLayout$DisplayName$3$Impersonating__f_$outer)) && (this.Lapp_layouts_MainLayout$DisplayName$3$Impersonating__f_name === x$0.Lapp_layouts_MainLayout$DisplayName$3$Impersonating__f_name)));
});
$c_Lapp_layouts_MainLayout$DisplayName$3$Impersonating.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_layouts_MainLayout$DisplayName$3$Impersonating.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_layouts_MainLayout$DisplayName$3$Impersonating.prototype.productPrefix__T = (function() {
  return "Impersonating";
});
$c_Lapp_layouts_MainLayout$DisplayName$3$Impersonating.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_layouts_MainLayout$DisplayName$3$Impersonating__f_name;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_layouts_MainLayout$DisplayName$3$Impersonating.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "name";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_layouts_MainLayout$DisplayName$3$Impersonating.prototype.ordinal__I = (function() {
  return 0;
});
function $isArrayOf_Lapp_layouts_MainLayout$DisplayName$3$Impersonating(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_layouts_MainLayout$DisplayName$3$Impersonating)));
}
export { $isArrayOf_Lapp_layouts_MainLayout$DisplayName$3$Impersonating as $isArrayOf_Lapp_layouts_MainLayout$DisplayName$3$Impersonating };
var $d_Lapp_layouts_MainLayout$DisplayName$3$Impersonating = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_layouts_MainLayout$DisplayName$3$Impersonating, "app.layouts.MainLayout$DisplayName$3$Impersonating", ({
  Lapp_layouts_MainLayout$DisplayName$3$Impersonating: 1,
  Lapp_layouts_MainLayout$DisplayName$1: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lapp_layouts_MainLayout$DisplayName$3$Impersonating as $d_Lapp_layouts_MainLayout$DisplayName$3$Impersonating };
//# sourceMappingURL=app.layouts.-Main-Layout$-Display-Name$3$-Impersonating.js.map
